import { app } from '../../../../app';

app.component('appIntegrationInstructionsRemote', {
    bindings: {instructions: '<'},
    templateUrl: require('./app-integration-instructions-remote.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/remote/app-integration-instructions-remote.component.js